import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import allPlugins from "../../utils/suneditorPlugins";
import "./CreateContract.css";
import SideCanvas from "./SideCanvas";
import TextEditorToSection from "./TextEditorToSection";
import apiClient, { getEditorUploadConfig } from '../../services/apiClient';
import Swal from "sweetalert2";
import { getErrorMessage } from "../../services/errorHelper";
import { useDispatch, useSelector } from "react-redux";
import { setTitle } from "../../redux/titleSlice";
import { useNavigate } from "react-router-dom/dist/umd/react-router-dom.development";

export default function CreateContract() {
  // Reference for the SunEditor instance
  const editorRef = useRef(null);
  let [contractCount, setContractCount] = useState(0);
  const [length, setlength] = useState(0);
  const title = useSelector((state) => state.title.title);
  const [contracttitle, setContracttitle] = useState("1");
  const [tabs, setTabs] = useState([]);
  const [editorInstance, setEditorInstance] = useState(null);
  const [editorInstances, setEditorInstances] = useState({});
  const [selectedValue1, setSelectedValue1] = useState("");

  const { contractId } = useParams();
  const navigate = useNavigate();
  const [contract, setContract] = useState(null);
  const dispatch = useDispatch();

  const getSunEditorInstance = (sunEditor, tabId) => {
    setEditorInstances((prev) => ({ ...prev, [tabId]: sunEditor }));
  };
  const handleSelectChange = (e) => {
    setSelectedValue1(e.target.value);
  };

  const openSmartTextCanvas = () => {
    // abre o offcanvas clicando no trigger oculto
    const btn = document.getElementById("smarttextpopup");
    if (btn) btn.click();
  };

  const handleInsertInputField = () => {
    const value = selectedValue1;

    if (!value) {
      Swal.fire({
        icon: "warning",
        title: "Select a field",
        text: "Please choose a smart text field first!",
      });
      return;
    }

    try {
      // find the active tab
      const activeTabId = document.querySelector(".tab-pane.active")?.id;
      if (!activeTabId) return;

      // pick the right editor for that tab
      const editor = editorInstances[activeTabId]; // 👈 make sure you stored editors by tabId in getSunEditorInstance
      if (editor) {
        editor.core.focus();
        editor.insertHTML(value);
      }
    } catch (err) {
      console.error("[SUNEDITOR.insertHTML.fail]", err);
    }
  };

  const handleEditorChange = (content, tabId) => {
    setTabs((prevTabs) =>
      prevTabs.map((tab) =>
        tab.id === tabId ? { ...tab, content: content } : tab
      )
    );
  };

  const renamepage = (tabId) => {
    const newTitle = prompt("Enter a new title for the page:");
    if (newTitle) {
      setTabs((prevTabs) =>
        prevTabs.map((tab) =>
          tab.id === tabId ? { ...tab, title: newTitle } : tab
        )
      );
    }
  };

  const handleClick = (id) => {
    setTabs((prevTabs) => prevTabs.filter((item) => item.id !== id));
  };

  const handleclone = (cloneid) => {
    //const clonetab = tabs.filter((item) => item.id === cloneid);
    const clonetab = tabs.filter((item) => item.id === cloneid);

    const newTabId = `v-pills-${contractCount + 2}`;
    const newTabContentId = `v-pills-content-${contractCount + 1}`;
    const newTabTitle = `Page ${contractCount + 1}`;

    const newTab = {
      id: newTabId,
      title: newTabTitle,
      content: clonetab[0].content,
    };
    setTabs([...tabs, newTab]);
    setContractCount((prevCount) => prevCount + 2);
  };

  useEffect(() => {
    const handler = () => {
      document.body.style.overflow = "auto";
    };
    window.addEventListener("shown.bs.offcanvas", handler);
    return () => {
      window.removeEventListener("shown.bs.offcanvas", handler);
    };
  }, []);

  useEffect(() => {
    if (editorRef.current) {
      editorRef.current.setContents("<p>Your default content goes here</p>");
    }
  }, []);

  useEffect(() => {
    // what should happen after the initial render
    const buttonid = `v-pills-${contractCount}-tab`;
    const activebutton = document.getElementById(buttonid);
    if (activebutton) {
      activebutton.click();
    }
    //active.setAttribute("data-scroll", <your_value>)
  }, [tabs.length]);

  //let c = contractCount;
  var count = 0;
  useEffect(() => {
    const fetchContract = async () => {
      try {
        const response = await apiClient.get(
          `/contracts/${contractId}`
        );
        // setContractContent(response.data.pages[0].content);

        setContract(response.data);
        count = 10;

        // setContractTitle(response.data.title);
        setContracttitle(response.data.title);


        response.data.pages.forEach((tabs1, index) => {
          //count++;
          const newTabTitle = tabs1.page_name;

          const newTab = {
            id: `v-pills-${index}`,
            title: newTabTitle,
            content: tabs1.content,
          };
          setTabs((tabs) => [...tabs, newTab]);

          // Use functional update for setTabs to ensure latest state
        });

        dispatch(setTitle(response.data.title));

        setContractCount(response.data.pages.length - 1);
      } catch (error) {
        console.error("Error fetching contract:", error);
      }
    };
    fetchContract();
  }, []);
  // setContractCount(count);
  if (!contract) {
    return <div>Loading...</div>;
  }

  const handleSubmit = async () => {
    try {
      await apiClient.put(
        `/contracts/${contractId}`,
        {
          title: title,
          pages: tabs.map((tab) => ({
            content: tab.content,
            page_name: tab.title,
          })),
        }
      );
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Contract updated successfully!",
      });
      navigate("/contracts");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: getErrorMessage(error),
      });
    }
  };
  // Custom SunEditor plugin for Add Smart Text
  const addSmartTextPlugin = {
    name: "addSmartText",
    display: "command",
    title: "Add Smart Text", // tooltip title
    innerHTML: '<i class="fa fa-magic"></i>',
    buttonClass: "sun-editor-action customAction p-3", // 👈 custom classes here
    add: function () {}, // required
    action: function () {
      const btn = document.getElementById("smarttextpopup");
      if (btn) btn.click();
    },
  };

  // Options for the SunEditor instance
  const editorOptions = {
    height: 200,
    ...getEditorUploadConfig(),
    buttonList: [
      [
        "codeView",
        "paragraphStyle",
        "bold",
        "underline",
        "italic",
        "strike",
        "table",
        "link",
        "horizontalRule",
        "list",
        "align",
        "hiliteColor",
        "image",
        "video",
        "addSmartText",
      ],
    ],
    plugins: [...allPlugins, addSmartTextPlugin],
    imageRotation: false,
    fontSize: [12, 14, 16, 18, 20],
    colorList: [
      [
        "#828282",
        "#FF5400",
        "#676464",
        "#F1F2F4",
        "#FF9B00",
        "#F00",
        "#fa6e30",
        "#000",
        "rgba(255, 153, 0, 0.1)",
        "#FF6600",
        "#0099FF",
        "#74CC6D",
        "#FF9900",
        "#CCCCCC",
        "#CCCCCC",
      ],
    ],
  };

  // Data for the default content of the SunEditor
  const data = `<div><h1>Contract</h1><p className="mt-5">Please type or copy and paste the content of your contract here. Alternatively, you can import one of your contract templates using the right panel. </p> <p className="mt-5">If you don’t have a contract, you can browse our template gallery for lawyer-approved free contracts.</p> <p  className="mt-5">And remember to delete this text before sending .</p>
  <p className="smart_text">smart_text</p>
  </div>`;

  // Function to handle adding a new contract page
  const handleAddContract = () => {
    const newTabId = `v-pills-${contractCount + 1}`;
    const buttonid = `v-pills-${contractCount + 1}-tab`;
    const newTabContentId = `v-pills-content-${contractCount + 1}`;
    const newTabTitle = `Page ${contractCount + 1}`;

    const newTab = {
      id: newTabId,
      title: newTabTitle,
      content: `<div>
        <h1>${newTabTitle}</h1>
        <p className="mt-5">Your new page content goes here.</p>
      </div>`,
    };

    setTabs([...tabs, newTab]);
    setContractCount((prevCount) => prevCount + 1);


    document.getElementById("offcanvasRight2").classList.remove("show");
    document.getElementById("offcanvasRight2").style.visibility = "hidden";
    // document.getElementById('v-pills-tab').click();
  };
  const deletepage = () => {
  };

  return (
    <>
      {/* Side canvas for the smart text */}
      <SideCanvas
      // Pass the function to handle smart text input change
      />
      <div className="container-fluid p-lg-5 p-md-5 p-3">
        <div className="row g-lg-5 row_mobile g-md-5 g-3 px-lg-5">
          {/* Text Editor part */}
          <div className="col-md-9">
            <div className="text-editor px-2 px-md-5 py-3">
              <div class="tab-content h-100" id="v-pills-tabContent">
                {/* text editor page */}
                {tabs.map((tab, index) => (
                  <div
                    key={tab.id}
                    className={
                      "tab-pane fade " +
                      (tab.id == "v-pills-home" ? "show active" : "")
                    }
                    id={tab.id}
                    role="tabpanel"
                    aria-labelledby={`${tab.id}-tab`}
                  >
                    {index == 0 ? <TextEditorToSection /> : ""}
                    <div className="position-relative overflow-hidden">
                      <SunEditor
                        setOptions={editorOptions}
                        ref={editorRef}
                        defaultValue={tab.content}
                        onChange={(content) =>
                          handleEditorChange(content, tab.id)
                        }
                        getSunEditorInstance={(instance) =>
                          getSunEditorInstance(instance, tab.id)
                        }
                      />
                    </div>
                  </div>
                ))}

                {/* add page */}
                <div
                  class="tab-pane fade h-100  text-center"
                  id="v-pills-profile"
                  role="tabpanel"
                  aria-labelledby="v-pills-profile-tab"
                >
                  <div className="add-page  d-flex flex-column justify-content-center align-items-center"></div>
                </div>
              </div>
            </div>
          </div>

          {/* Contract Right Area */}
          <div className="col-md-3">
            <span class="placeholder col-6"></span>

            <div className="row">
              <div className="col-12">
                <div className="right-side-area">
                  <div
                    class="nav flex-column nav-pills me-3"
                    id="v-pills-tab"
                    role="tablist"
                    aria-orientation="vertical"
                  >
                    {/* Current Page Start: Contract Box */}
                    {tabs.map((tab) => (
                      <button
                        key={tab.id}
                        className={`nav-link ${
                          tab.id === "v-pills-home" ? "active" : ""
                        }`}
                        id={`${tab.id}-tab`}
                        data-bs-toggle="pill"
                        data-bs-target={`#${tab.id}`}
                        type="button"
                        role="tab"
                        aria-controls={tab.id}
                        aria-selected={
                          tab.id === "v-pills-home" ? "true" : "false"
                        }
                      >
                        <div className="right-side-box">
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                              <div
                                className="icon-box active bg-white"
                                role="button"
                              >
                                <div className="row gap-2 align-items-start m-2">
                                  <div className="col-12 skeleton-one"></div>
                                  <div className="col-12 skeleton-two"></div>
                                  <div className="col-12 skeleton-three"></div>
                                  <div className="col-12 skeleton-four"></div>
                                </div>
                              </div>
                              <h5 className="box-title">{tab.title}</h5>
                            </div>
                            <div
                              className="nav-item dropdown"
                              id="top-user-nav"
                            >
                              <div
                                className="nav-link dropdown"
                                data-bs-toggle="dropdown"
                              >
                                <div className="three-dot-btn">
                                  <button
                                    className="border-0 bg-transparent"
                                    type="button"
                                  >
                                    <i className="fa-solid fa-ellipsis-vertical"></i>
                                  </button>
                                </div>
                              </div>
                              <div className="dropdown-menu shadow-sm border-0 py-4 px-4">
                                <Link to="#">
                                  <div
                                    className="link-btn mb-4 rename-page-btn"
                                    data-tab={tab.id}
                                    onClick={() => renamepage(tab.id)}
                                  >
                                    <i
                                      className="fa fa-pencil"
                                      aria-hidden="true"
                                    ></i>
                                    <span>Rename</span>
                                  </div>
                                </Link>
                                <Link to="#">
                                  <div
                                    className="link-btn mb-4 duplicate-page-btn"
                                    data-tab={tab.id}
                                    onClick={() => handleclone(tab.id)}
                                  >
                                    <i className="fa-solid fa-clone"></i>
                                    <span>Duplicate</span>
                                  </div>
                                </Link>
                                <Link to="#">
                                  <div
                                    className="link-btn text-danger delete-page-btn"
                                    data-tab={tab.id}
                                    onClick={() => handleClick(tab.id)}
                                  >
                                    <i className="fa-solid fa-trash"></i>
                                    <span>Delete</span>
                                  </div>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </button>
                    ))}
                    {/* Current Page End: Contract Box */}

                    {/* Add Page Start: New Page */}
                    <button
                      class="nav-link"
                      id="v-pills-profile-tab"
                      onClick={handleAddContract}
                      type="button"
                      role="tab"
                      aria-controls="v-pills-profile"
                      aria-selected="false"
                    >
                      {/* Add Page: New Page */}
                      <div className="right-side-box">
                        <div className="d-flex align-items-center justify-content-between">
                          <div
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRight2"
                            aria-controls="offcanvasRight2"
                            data-bs-scroll="true"
                            className="d-flex align-items-center"
                          >
                            <div
                              className="icon-box icon-box-add-page"
                              role="button"
                            >
                              <span>
                                <i class="fa-solid fa-plus"></i>
                              </span>
                            </div>
                            Add
                          </div>
                          {/* Dropdown */}
                          <div
                            className="nav-item dropdown"
                            id="top-user-nav"
                            aria-disabled="true"
                          >
                            <div
                              href="#"
                              className="nav-link dropdown"
                              data-bs-toggle="dropdown"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </button>
                    {/* Add Page End: New Page */}
                  </div>

                  <div className="text-center pt-2">
                    <button
                      id="submit-btn"
                      type="button"
                      className="px-5 rounded-pill btn btn-primary btn-lg text-uppercase"
                      onClick={handleSubmit}
                    >
                      Save
                    </button>
                  </div>

                  {/* Add page canvas */}
                  <div className="create-contract">
                    <div
                      class="offcanvas offcanvas-end"
                      tabindex="-1"
                      id="offcanvasRight2"
                      aria-labelledby="offcanvasRightLabel"
                      data-bs-backdrop="false"
                    >
                      <div class="w-100 text-start header">
                        <button
                          type="button"
                          class="btn-close mt-3 ms-4 text-black"
                          data-bs-dismiss="offcanvas"
                          aria-label="Close"
                        ></button>

                        <div className="text-center py-3">
                          <h5>Add Page</h5>
                          <span style={{ color: "#727272" }}>
                            Select from the list below
                          </span>
                        </div>
                      </div>
                      <div class="w-100 text-start header">
                        <div
                          className="text-center py-3 single_box"
                          onClick={handleAddContract}
                        >
                          <span>+ Page With Text Only</span>
                        </div>
                      </div>

                      <div class="offcanvas-body p-0">
                        <h5 className="px-4 py-2">Contracts</h5>

                        <div className="single_box mt-3">
                          <div className="d-flex align-items-center justify-content-between">
                            <div onClick={handleAddContract}>
                              <h6>New Contract</h6>
                              <div className="d-flex align-items-center mt-1">
                                <i class="far fa-folder"></i>
                                <span className="ms-2">Contract</span>
                              </div>
                            </div>
                            <div className="icon">
                              <i class="fa fa-chevron-right"></i>
                            </div>
                          </div>
                        </div>

                        <div className="single_box mt-4">
                          <div className="d-flex align-items-center justify-content-between">
                            <div>
                              <h6>Basic Booth Contract</h6>
                              <div className="d-flex align-items-center mt-1">
                                <i class="far fa-folder"></i>
                                <span className="ms-2">Contract</span>
                              </div>
                            </div>
                            <div className="icon">
                              <i class="fa fa-chevron-right"></i>
                            </div>
                          </div>
                        </div>

                        <div>
                          <h5 className="py-4 px-4">Invoice</h5>
                          <div className="single_box mt-3">
                            <div className="d-flex align-items-center justify-content-between">
                              <div>
                                <h6>New Invoice</h6>
                                <div className="d-flex align-items-center mt-1">
                                  <i class="far fa-folder"></i>
                                  <span className="ms-2">Invoice</span>
                                </div>
                              </div>
                              <div className="icon">
                                <i class="fa fa-chevron-right"></i>
                              </div>
                            </div>
                          </div>
                          <div className="single_box mt-4">
                            <div className="d-flex align-items-center justify-content-between">
                              <div>
                                <h6>Click Firefly - 2 Hour Invoice</h6>
                                <div className="d-flex align-items-center mt-1">
                                  <i class="far fa-folder"></i>
                                  <span className="ms-2">Invoice</span>
                                </div>
                              </div>
                              <div className="icon">
                                <i class="fa fa-chevron-right"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="smarttextpopup"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasRightSmartText"
        aria-controls="offcanvasRightSmartText"
        className="d-none"
      />
      {/* Smart Text canvas */}
      <div className="create-contract">
        <div
          className="offcanvas offcanvas-end"
          tabIndex="-1"
          id="offcanvasRightSmartText"
          aria-labelledby="offcanvasSmartTextLabel"
          data-bs-backdrop="false"
        >
          <div className="w-100 text-start header">
            <button
              type="button"
              className="btn-close mt-3 ms-4 text-black"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            />
            <div className="text-center py-3">
              <h5>Smart Text</h5>
            </div>
          </div>

          <div className="offcanvas-body p-4">
            <div className="single_box">
              <h6>Field content types: {selectedValue1}</h6>
              <select
                value={selectedValue1}
                onChange={handleSelectChange}
                style={{
                  width: "300px",
                  height: "40px",
                  outline: "none",
                  backgroundColor: "#ffffff",
                  border: "1px solid #e8e4e4",
                }}
              >
                <option value="" disabled>
                  Select your option
                </option>
                <option value="{Event_Name}">Event Name</option>
                <option value="{First_Client_First_Name}">
                  First Client First Name
                </option>
                <option value="{First_Client_Last_Name}">
                  First Client Last Name
                </option>
                <option value="{First_Client_Email}">
                  First Client Email
                </option>
                <option value="{Event_Type}">Event Type</option>
              </select>
            </div>

            <div className="single_box mt-4">
              <button
                onClick={handleInsertInputField}
                style={{
                  width: "120px",
                  height: "40px",
                  borderRadius: "20px",
                  outline: "none",
                  backgroundColor: "#4f46e5",
                  border: "1px solid #e8e4e4",
                  color: "#fff",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                }}
              >
                Insert
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
